import { Check, CheckCircle } from "@phosphor-icons/react";

const NEXT_STEPS = ["Details received", "Two connectors next", "Password deleted after setup"];

export function SuccessState({ networkName }: { networkName: string }) {
  return (
    <main className="mx-auto flex min-h-[calc(100vh-105px)] max-w-[880px] items-center px-5 py-12 sm:px-8">
      <div className="w-full overflow-hidden rounded-[28px] bg-white shadow-[0_24px_80px_-42px_rgba(40,35,31,0.5)]">
        <div className="bg-success h-2" />
        <div className="px-6 py-10 text-center sm:px-12 sm:py-14">
          <div className="bg-success-subtle mx-auto flex size-16 items-center justify-center rounded-full">
            <CheckCircle className="text-success size-9" weight="fill" aria-hidden />
          </div>
          <p className="text-success mt-6 text-[12px] tracking-[0.1em] uppercase">
            Shared securely
          </p>
          <h1 className="text-primary mx-auto mt-3 max-w-[620px] text-[36px] leading-[1.12] tracking-[-0.025em] sm:text-[48px]">
            We have what we need to prepare your kit.
          </h1>
          <p className="text-muted mx-auto mt-5 max-w-[560px] text-[17px] leading-7">
            Your network <span className="text-primary">{networkName}</span> is ready for our setup
            team. We will configure both connectors, test them, and delete your stored password once
            we have confirmed they work.
          </p>

          <div className="mx-auto mt-9 grid max-w-[620px] gap-3 text-left sm:grid-cols-3">
            {NEXT_STEPS.map((label, index) => (
              <div key={label} className="bg-background rounded-xl p-4">
                <span className="bg-success-subtle text-success flex size-7 items-center justify-center rounded-full">
                  {index === 0 ? <Check className="size-4" weight="bold" /> : index + 1}
                </span>
                <p className="text-primary mt-3 text-[13px] leading-5">{label}</p>
              </div>
            ))}
          </div>

          <div className="border-border-subtle mx-auto mt-9 max-w-[620px] border-t pt-6">
            <p className="text-muted text-[12px] leading-5">
              You can close this page. The link has now been used and will not open again.
            </p>
          </div>
        </div>
      </div>
    </main>
  );
}
